import React from 'react'

function Shorter() {
  return (
    <div className='bg-[#392f54]  sm:left-[9rem] sm:top-[38rem] sm:w-[80%] h-[9rem] top-[45rem] left-[1.20rem] rounded-lg w-[21rem] absolute'>
    <input type='text' placeholder='Shorten a link here...' className='absolute pl-5 sm:h-[3rem] sm:top-[3rem] font-medium rounded-md top-[1.80rem] h-[2.50rem] w-[86%] left-[1.40rem]' />
    <button className='bg-[#2bd1d1] hover:cursor-pointer hover:bg-[rgb(100,216,216)] sm:ml-3 sm:pt-3 sm:top-[3rem] sm:h-[3rem] sm:left-[60rem]  sm:w-[6rem] text-center text-lg pt-[6px] font-medium text-white  absolute rounded-md top-[5rem] h-[2.50rem] w-[86%] left-[1.40rem]'>Shorten It!</button>
    </div>
  )
}

export default Shorter